import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { apiClient, formatApiError, TOKEN_KEY } from "../lib/api";
import { toast } from "sonner";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Panel agenta · Logowanie";
    if (localStorage.getItem(TOKEN_KEY)) {
      navigate("/admin", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await apiClient.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      toast.success("Zalogowano");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Błąd logowania");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-bordersoft rounded-2xl p-8 md:p-10 shadow-sm">
          <div className="flex items-center justify-center w-14 h-14 rounded-full bg-forest/8 mx-auto mb-6">
            <Lock size={26} className="text-forest" />
          </div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-forest text-center">
            Panel agenta
          </h1>
          <p className="text-ink-muted text-center mt-2 text-base">
            Zaloguj się, aby zobaczyć nadesłane zgłoszenia.
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email" className="text-forest font-semibold mb-2 block">
                E-mail
              </Label>
              <Input
                id="email"
                type="email"
                data-testid="admin-login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-12 text-base bg-cream border-bordersoft focus-visible:ring-forest"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-forest font-semibold mb-2 block">
                Hasło
              </Label>
              <Input
                id="password"
                type="password"
                data-testid="admin-login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-12 text-base bg-cream border-bordersoft focus-visible:ring-forest"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-forest hover:bg-forest-dark disabled:opacity-60 text-cream font-semibold text-base transition-colors min-h-[52px]"
            >
              {loading && <Loader2 size={18} className="animate-spin" />}
              {loading ? "Logowanie..." : "Zaloguj się"}
            </button>
          </form>
        </div>
        <div className="text-center mt-6">
          <a href="/" className="text-forest hover:text-mustard-dark text-sm font-medium">
            ← Powrót na stronę
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
